#import "../fragments/email-sequence-template-fragment.graphql"

query GetArchivedEmailSequenceTemplates {
    emailSequenceTemplateCollection {
        archivedTemplates {
            ...EmailSequenceTemplate
        }
    }
}
